import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import './SuccessModal.css';

const SuccessModal = ({
  visible,
  onClose,
  onProceed,
  title,
  description,
  buttonText = "Proceed",
  imagePath,
  buttonColor = "#006400"
}) => {
  const modalRef = useRef(null);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (visible) {
      setIsAnimating(true);
      document.body.style.overflow = 'hidden';
      
      const timer = setTimeout(() => {
        if (modalRef.current) {
          modalRef.current.classList.add('active');
        }
      }, 10);
      
      return () => clearTimeout(timer);
    } else {
      if (modalRef.current) {
        modalRef.current.classList.remove('active');
      }
      
      const timer = setTimeout(() => {
        setIsAnimating(false);
        document.body.style.overflow = '';
      }, 300);
      
      return () => clearTimeout(timer);
    }
  }, [visible]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!visible && !isAnimating) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div 
        ref={modalRef} 
        className="modal-container"
      >
        <div className="handle-container">
          <div className="handle"></div>
        </div>

        <button className="close-button" onClick={onClose}>
          ✕
        </button>

        <div className="content-wrapper">
          <div className="image-container">
            <img 
              src={imagePath} 
              alt="Success" 
              className="modal-image"
            />
          </div>

          <div className="text-container">
            <h2 className="title">{title}</h2>
            <p className="description">{description}</p>
          </div>

          <div className="button-container">
            <button 
              className="custom-button" 
              onClick={onProceed}
              style={{ backgroundColor: buttonColor }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

SuccessModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onProceed: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  imagePath: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  buttonColor: PropTypes.string
};

export default SuccessModal;